module.exports = __webpack_public_path__ + "static/img/HK.e5c8bbb8.svg";